export default __webpack_public_path__ + "static/media/background-992.94c45676.jpeg";